import React, { useState } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	InputAdornment,
	TextField
} from '@material-ui/core'
import { useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import { updateVisitLineItem } from '../../../actions/lineItems/lineItems.actions'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '18px !important'
	},
	fieldWrapper: {
		marginBottom: '8px',
		'& .MuiTextField-root': {
			minWidth: '100%',
			marginBottom: '16px'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '100%'
		}
	}
}))

const EditLineItemDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	let { isShown, visit, selectedItem, setSelectedItem, setIsShown, saveVisit } = props

	const [updatedPrice, setUpdatedPrice] = useState(0)

	const onlyNumbers = (value) => {
		if (!value || value === '0') return value
		const onlyNums = value.toString().replace(/[^\d]/g, '').replace(/^0+/, '')
		if (onlyNums.length) return onlyNums
		return 0
	}

	const formatNumsToDollars = (value) => {
		if (value !== undefined && value !== null) {
			return `${(value / 100).toFixed(2)}`
		}
		return ''
	}

	return (
		<Dialog
			open={isShown}
			onExited={() => setUpdatedPrice(0)}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24,
					textTransform: 'uppercase'
				}}>
				Edit Invoice Item
			</DialogTitle>
			<DialogContent>
				{selectedItem ? (
					<div>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Description"
								variant="filled"
								value={selectedItem.description || ''}
								disabled
								className="calculated-field"
								onChange={(e) => null}
							/>
						</div>
						<div className={classes.fieldWrapper}>
							<TextField
								label="Price"
								variant="filled"
								value={formatNumsToDollars(onlyNumbers(selectedItem.price || 0))}
								disabled
								className="calculated-field"
								onChange={(e) => null}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
							/>
						</div>
						<div className={classes.fieldWrapper}>
							<TextField
								variant="filled"
								label="Update Total Amount"
								value={formatNumsToDollars(onlyNumbers(updatedPrice))}
								onChange={(e) => setUpdatedPrice(e.target.value)}
								InputProps={{
									startAdornment: (
										<InputAdornment className={classes.currencyAdornment} position="start">
											$
										</InputAdornment>
									)
								}}
							/>
						</div>
					</div>
				) : (
					<Typography>No Item Selected</Typography>
				)}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						let price = formatNumsToDollars(onlyNumbers(updatedPrice))

						price = onlyNumbers(price)

						if (!selectedItem._id && visit.type === 'grooming') {
							const isTip = selectedItem.description?.includes('Tip')
							const updates = {}
							if (isTip) {
								updates.tip = price
								updates.manual_tip_amount = price
								updates.tip_percent = null
							} else {
								updates.price = price
							}
							saveVisit(updates)
						} else {
							dispatch(
								updateVisitLineItem(selectedItem._id, {
									amount: price
								})
							)
						}

						setIsShown(false)
					}}
					color="secondary"
					disabled={!updatedPrice}>
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditLineItemDialog
